import type { BillingPlanListType } from '@shared/core/billing'
import { useContext, useEffect, useMemo } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { FormattedText } from 'src/modules/core/components'
import { LoadingWrapperContext } from 'src/modules/core/context'
import { PlansOffer } from 'src/modules/payment/containers/plans-offer'
import { parseUpgradeFunnelParams } from 'src/modules/payment/utils/upgrade-funnel-navigation'
import classes from './subscription-plans.module.scss'

// Old links to the retired hard wall carry `type=limit`; the server counts them.
const RETIRED_WALL_PLANS_TYPE: BillingPlanListType = 'limit'

export function SubscriptionPlans() {
  const { disableLoading } = useContext(LoadingWrapperContext)
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const params = useMemo(() => parseUpgradeFunnelParams(searchParams), [searchParams])
  const plansType = searchParams.get('type') === RETIRED_WALL_PLANS_TYPE ? RETIRED_WALL_PLANS_TYPE : undefined

  useEffect(() => {
    disableLoading()
  }, [disableLoading])

  return (
    <main className={classes.root}>
      <h1 className={classes.title}>
        <FormattedText id="payment.plans.page.title" />
      </h1>
      <p className={classes.subtitle}>
        <FormattedText id="payment.plans.page.subtitle" />
      </p>
      <PlansOffer surface="plans_page" params={params} plansType={plansType} priceSuffix="mo" />
      <button type="button" className={classes.back} onClick={() => navigate(-1)}>
        <FormattedText id="payment.plans.page.back" />
      </button>
    </main>
  )
}
